/* eslint-disable max-len */
import React from 'react'

export function OxygenWhite() {
  return (
    <svg
      width="100px"
      height="100px"
      viewBox="0 0 100 100"
      xmlns="http://www.w3.org/2000/svg">
      <g
        id="ic_oxygen"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd">
        <circle
          id="Oval"
          stroke="#ffffff"
          strokeWidth="4"
          cx="50"
          cy="50"
          r="33"
        />
        <text
          id="O2"
          fontFamily="AvenirNext-Bold, Avenir Next"
          fontSize="15"
          fontWeight="bold"
          letterSpacing="0.103125"
          fill="#ffffff">
          <tspan x="38.169375" y="69">
            O2
          </tspan>
        </text>
        <line
          x1="53.5"
          y1="42.5"
          x2="63.5"
          y2="30.5"
          id="Line"
          stroke="#ffffff"
          strokeWidth="3"
          strokeLinecap="square"
        />
        <circle id="Oval" fill="#ffffff" cx="50" cy="47" r="6" />
      </g>
    </svg>
  )
}

export function TemperatureWhite() {
  return (
    <svg
      width="100px"
      height="100px"
      viewBox="0 0 100 100"
      xmlns="http://www.w3.org/2000/svg">
      <g
        id="ic_water_temp"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd">
        <g
          id="Group-9"
          transform="translate(44.000000, 14.000000)"
          fill="#ffffff">
          <g id="thermometer">
            <path
              d="M29.9999531,40.5833906 L29.9999531,11.9999531 C29.9999531,5.37257812 24.627375,0 18,0 C11.372625,0 6.00004688,5.37257812 6.00004688,11.9999531 L6.00004688,40.58325 C2.3175,43.8792187 0,48.6690469 0,54 C0,63.9412031 8.0589375,72 18,72 C27.9410625,72 36,63.9412031 36,54 C36,48.6690469 33.6825,43.8792187 29.9999531,40.5833906 Z M18,65.9999531 C11.372625,65.9999531 6.00004687,60.627375 6.00004687,54 C6.00004687,50.5354219 7.4683125,47.3214375 10.0015312,45.0541406 L12.0000937,43.2653906 L12.0000937,11.9999531 C12.0000937,8.68626562 14.6864531,5.99990625 18.0001406,5.99990625 C21.3138281,5.99990625 24.0001875,8.686125 24.0001875,11.9999531 L24.0001875,43.2653906 L25.99875,45.0541406 C28.5319687,47.3214375 30.0002344,50.5352812 30.0002344,54 C29.9999531,60.627375 24.627375,65.9999531 18,65.9999531 Z"
              id="Shape"
            />
            <rect
              id="Rectangle"
              x="15.0000469"
              y="24.0000469"
              width="6.00004688"
              height="36"
            />
            <circle id="Oval" cx="18" cy="54" r="9" />
          </g>
        </g>
        <g id="drop" transform="translate(24.000000, 31.000000)" fill="#ffffff">
          <path
            d="M17.2495448,8.144625 C14.7374752,4.2096875 12.1888968,0.9643125 12.1634777,0.9319375 L11.4296252,0 L10.695835,0.932 C10.6704159,0.9643125 8.12183748,4.2096875 5.60976793,8.1446875 C2.17245483,13.52875 0.4296875,17.6054375 0.4296875,20.2615 C0.4296875,26.734125 5.36423666,32 11.4296875,32 C17.4951383,32 22.4296875,26.734125 22.4296875,20.2615 C22.4296875,17.6054375 20.6868579,13.52875 17.2495448,8.144625 Z"
            id="Path"
          />
        </g>
      </g>
    </svg>
  )
}

export function SpeedWhite() {
  return (
    <svg
      fill="#ffffff"
      width="100px"
      height="100px"
      viewBox="0 0 100 100"
      xmlns="http://www.w3.org/2000/svg">
      <g id="ic_current_speed" stroke="none" strokeWidth="1">
        <g id="wind" transform="translate(14.000000, 24.000000)">
          <path
            d="M0.954160156,26.6849023 C5.09509766,30.2367187 9.78837891,34.2626758 18.8666406,34.2626758 C27.9451758,34.2626758 32.6387305,30.2367187 36.7798047,26.6849023 C40.6959766,23.3259961 44.078125,20.4249609 51.1325391,20.4249609 C58.1870898,20.4249609 61.5692383,23.3259961 65.4852734,26.6849023 C66.6316602,27.6680469 68.3578711,27.5359766 69.3410156,26.3897266 C70.3241602,25.2433398 70.1920898,23.5171289 69.0457031,22.5339844 C64.9046289,18.982168 60.2110742,14.9562109 51.1325391,14.9562109 C42.0540039,14.9562109 37.3604492,18.9820312 33.219375,22.5339844 C29.3032031,25.8928906 25.9210547,28.7939258 18.8666406,28.7939258 C11.8123633,28.7939258 8.430625,25.8930273 4.51472656,22.5339844 C3.36847656,21.5508398 1.64226562,21.6827734 0.658984375,22.8291602 C-0.324296875,23.9754102 -0.192089844,25.7017578 0.954160156,26.6849023 Z"
            id="Path"
          />
          <path
            d="M0.954160156,11.7286914 C5.09496094,15.2806445 9.78824219,19.3064648 18.8666406,19.3064648 C27.9451758,19.3064648 32.6387305,15.2806445 36.7798047,11.7286914 C40.6959766,8.36978516 44.0779883,5.46875 51.1325391,5.46875 C58.1868164,5.46875 61.5689648,8.36964844 65.4852734,11.7286914 C66.6316602,12.7121094 68.3577344,12.5796289 69.3408789,11.4332422 C70.3241602,10.2869922 70.1916797,8.56050781 69.0454297,7.5775 C64.9043555,4.02554687 60.2108008,0 51.1325391,0 C42.0540039,0 37.3604492,4.02582031 33.219375,7.57777344 C29.3032031,10.9366797 25.9210547,13.8377148 18.8666406,13.8377148 C11.8125,13.8377148 8.430625,10.9368164 4.51472656,7.57777344 C3.36847656,6.59449219 1.64212891,6.7265625 0.658984375,7.87294922 C-0.324296875,9.01919922 -0.192089844,10.7455469 0.954160156,11.7286914 Z"
            id="Path"
          />
          <path
            d="M69.0457031,37.4900586 C64.9046289,33.9382422 60.2110742,29.9122852 51.1325391,29.9122852 C42.0540039,29.9122852 37.3604492,33.9381055 33.219375,37.4900586 C29.3032031,40.8489648 25.9210547,43.75 18.8666406,43.75 C11.8127734,43.75 8.43076172,40.8491016 4.51486328,37.490332 L4.51458984,37.4900586 C3.36833984,36.5071875 1.64226563,36.6392578 0.658984375,37.7853711 C-0.324160156,38.9316211 -0.191953125,40.6579688 0.954296875,41.6411133 C5.09523438,45.1930664 9.78865234,49.21875 18.8666406,49.21875 C27.9451758,49.21875 32.6387305,45.1929297 36.7798047,41.6409766 C40.6959766,38.2820703 44.078125,35.3810352 51.1325391,35.3810352 C58.1870898,35.3810352 61.5692383,38.2820703 65.4852734,41.6409766 C66.6316602,42.6241211 68.3578711,42.4920508 69.3410156,41.3458008 C70.3241602,40.1994141 70.1920898,38.4732031 69.0457031,37.4900586 Z"
            id="Path"
          />
        </g>
      </g>
    </svg>
  )
}

export function TideWhite() {
  return (
    <svg
      width="100px"
      height="100px"
      viewBox="0 0 100 100"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg">
      <g
        id="ic_tide"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd">
        <g
          id="tide"
          transform="translate(15.000000, 15.000000)"
          fill="#ffffff"
          fillRule="nonzero">
          <path
            d="M16.6078431,18.8039216 L16.6078431,28.931832 L13.2595742,25.5835631 C12.4558824,24.7793351 11.1519608,24.7793351 10.348269,25.5835631 C9.54404102,26.3872549 9.54404102,27.6911765 10.348269,28.4948683 L17.2110141,35.3576134 C17.6131281,35.7597273 18.1396293,35.9607843 18.6666667,35.9607843 C19.1937041,35.9607843 19.7207415,35.7597273 20.1223193,35.3576134 L26.9850644,28.4948683 C27.7892923,27.6911765 27.7892923,26.3872549 26.9850644,25.5835631 C26.1813725,24.7793351 24.877451,24.7793351 24.0737592,25.5835631 L20.7254902,28.931832 L20.7254902,18.8039216 C20.7254902,17.6667433 19.8038449,16.745098 18.6666667,16.745098 C17.5294884,16.745098 16.6078431,17.6667433 16.6078431,18.8039216 Z"
            id="Path"
          />
          <path
            d="M3.51501225,10.3772212 L6.8627451,7.02948839 L6.8627451,17.1568627 C6.8627451,18.294041 7.78439035,19.2156863 8.92156863,19.2156863 C10.0587469,19.2156863 10.9803922,18.294041 10.9803922,17.1568627 L10.9803922,7.02948839 L14.3286611,10.3772212 C14.7307752,10.7793351 15.2572763,10.9803922 15.7843137,10.9803922 C16.3113511,10.9803922 16.8383885,10.7793351 17.2399663,10.3772212 C18.0441943,9.57352941 18.0441943,8.26960784 17.2399663,7.46591602 L10.3772212,0.603170922 C9.57352941,-0.20105702 8.26960784,-0.20105702 7.46591602,0.603170922 L0.603170922,7.46591602 C-0.20105702,8.26960784 -0.20105702,9.57352941 0.603170922,10.3772212 C1.40686275,11.1814492 2.71078431,11.1814492 3.51501225,10.3772212 Z"
            id="Path"
          />
          <path
            d="M54.2231925,31.5621936 C58.265242,31.5621936 62.3072917,30.0234376 65.3842678,26.9464614 C71.5387562,20.791973 71.5387562,10.7782629 65.3842678,4.62377451 C60.9518995,0.191406216 54.313266,-1.19829967 48.4718904,1.08302696 C47.5609681,1.43903186 47.0264247,2.38641241 47.1920956,3.34987745 C47.3577665,4.31387875 48.1786152,5.02803302 49.1565564,5.05859378 C50.5575214,5.10255818 51.8748467,5.67195163 52.8645833,6.6622242 C53.9015013,7.69914216 54.4725031,9.07758888 54.4725031,10.5439644 C54.4725031,12.0108762 53.9015013,13.3893229 52.8645833,14.4262408 C50.7237286,16.5670956 47.2408855,16.5670956 45.1000307,14.4262408 C44.1102941,13.4365043 43.5409007,12.119715 43.4969363,10.7182139 C43.4658395,9.74080882 42.7522212,8.91996014 41.7882199,8.7537531 C40.8242188,8.58861829 39.8773744,9.12262565 39.5213695,10.0335477 C37.2395067,15.8749234 38.6292126,22.513557 43.062117,26.9459252 C46.1390931,30.0234376 50.1811428,31.5621936 54.2231925,31.5621936 L54.2231925,31.5621936 Z"
            id="Path"
          />
          <path
            d="M68.3969056,40.1293658 C67.4597121,39.9170497 66.4994639,40.3813572 66.0839461,41.248315 C64.9274663,43.6642157 62.4236366,45.2254902 59.7058824,45.2254902 C56.9881281,45.2254902 54.4842984,43.6642157 53.3278186,41.248315 C52.9852175,40.5336244 52.2630209,40.0784314 51.4705882,40.0784314 C50.6781556,40.0784314 49.955959,40.5330882 49.613894,41.248315 C48.4568781,43.6642157 45.9530484,45.2254902 43.2352941,45.2254902 C40.5175399,45.2254902 38.0137101,43.6642157 36.8572304,41.248315 C36.5146293,40.5336244 35.7924327,40.0784314 35,40.0784314 C34.2075673,40.0784314 33.4853707,40.5330882 33.1433057,41.248315 C31.9862899,43.6642157 29.4824601,45.2254902 26.7647059,45.2254902 C24.0469516,45.2254902 21.5431219,43.6642157 20.3866422,41.248315 C20.044041,40.5336244 19.3218444,40.0784314 18.5294118,40.0784314 C17.7369791,40.0784314 17.0147825,40.5330882 16.6727175,41.248315 C15.5157016,43.6642157 13.0118719,45.2254902 10.2941176,45.2254902 C7.57636339,45.2254902 5.07253367,43.6642157 3.91605392,41.248315 C3.50053612,40.3808211 2.54028792,39.9159773 1.60309443,40.1293658 C0.665364549,40.3427543 0,41.1759345 0,42.1372549 L0,52.1011029 C0.0707720588,51.9745711 0.138863392,51.8453585 0.202129255,51.7140013 C0.544194275,50.9987745 1.26639086,50.5441176 2.05882353,50.5441176 C2.8512562,50.5441176 3.57345278,50.9987745 3.91605392,51.7140013 C5.07253367,54.129902 7.57636339,55.6911765 10.2941176,55.6911765 C13.0118719,55.6911765 15.5157016,54.129902 16.6727175,51.7140013 C17.0147825,50.9987745 17.7369791,50.5441176 18.5294118,50.5441176 C19.3218444,50.5441176 20.044041,50.9987745 20.3866422,51.7140013 C21.5431219,54.129902 24.0469516,55.6911765 26.7647059,55.6911765 C29.4824601,55.6911765 31.9862899,54.129902 33.1433057,51.7140013 C33.4853707,50.9987745 34.2075673,50.5441176 35,50.5441176 C35.7924327,50.5441176 36.5146293,50.9987745 36.8572304,51.7140013 C38.0137101,54.129902 40.5175399,55.6911765 43.2352941,55.6911765 C45.9530484,55.6911765 48.4568781,54.129902 49.613894,51.7140013 C49.955959,50.9987745 50.6781556,50.5441176 51.4705882,50.5441176 C52.2630209,50.5441176 52.9852175,50.9987745 53.3278186,51.7140013 C54.4842984,54.129902 56.9881281,55.6911765 59.7058824,55.6911765 C62.4236366,55.6911765 64.9274663,54.129902 66.0844822,51.7140013 C66.4265472,50.9987745 67.1487438,50.5441176 67.9411765,50.5441176 C68.7336091,50.5441176 69.4558057,50.9987745 69.7984069,51.7140013 C69.8611366,51.8453585 69.9292279,51.9745711 70,52.1011029 L70,42.1372549 C70,41.1759345 69.3346355,40.3422181 68.3969056,40.1293658 L68.3969056,40.1293658 Z"
            id="Path"
          />
          <path
            d="M67.9411765,56.2166054 C65.8550092,58.4614737 62.8707874,59.8088235 59.7058824,59.8088235 C56.5409773,59.8088235 53.5567555,58.4620098 51.4705882,56.2166054 C49.3844209,58.4614737 46.4001992,59.8088235 43.2352941,59.8088235 C40.0703891,59.8088235 37.0861673,58.4620098 35,56.2166054 C32.9138327,58.4614737 29.9296109,59.8088235 26.7647059,59.8088235 C23.5998008,59.8088235 20.6155791,58.4620098 18.5294118,56.2166054 C16.4432445,58.4614737 13.4590227,59.8088235 10.2941176,59.8088235 C7.12921259,59.8088235 4.14499084,58.4620098 2.05882353,56.2166054 C1.44439345,56.8776807 0.75168498,57.4604779 0,57.9542739 L0,68.2156863 C0,69.3528645 0.921645255,70.2745098 2.05882353,70.2745098 L67.9411765,70.2745098 C69.0783547,70.2745098 70,69.3528645 70,68.2156863 L70,57.9542739 C69.248315,57.4604779 68.5556065,56.8776807 67.9411765,56.2166054 Z"
            id="Path"
          />
        </g>
      </g>
    </svg>
  )
}

export function SaturationWhite() {
  return (
    <svg
      width="100px"
      height="100px"
      viewBox="0 0 100 100"
      xmlns="http://www.w3.org/2000/svg">
      <g
        id="ic_saturation"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd">
        <g
          id="saturation"
          transform="translate(18.000000, 11.000000)"
          fill="#ffffff">
          <path d="M55.3795133,31.2633513 C53.0162382,26.4674864 49.7345424,21.420654 45.6246545,16.2626791 C38.6716662,7.53618858 31.8190645,1.55898474 31.5304522,1.30861513 L30.0228559,0 L28.4985285,1.29009131 C28.2099161,1.53448559 21.3483516,7.37604756 14.3893876,16.0374061 C10.2759146,21.1571384 6.99123108,26.1985928 4.62616341,31.0231399 C1.60738553,37.1825936 0.0764852631,43.0265458 0.0764852631,48.3936601 C0.0764852631,64.8953556 13.5020391,78.3209095 30.0037346,78.3209095 C46.5060277,78.3209095 59.930984,64.8953556 59.930984,48.3936601 C59.930984,43.1574072 58.3994861,37.3941232 55.3795133,31.2633513 Z M30.0037346,73.6624789 C16.0708684,73.6624789 4.73491582,62.3271238 4.73491582,48.3936601 C4.73491582,30.6783585 24.3133505,11.414828 29.9870035,6.20546448 C35.648108,11.5086419 55.2731509,31.1414529 55.2731509,48.3936601 C55.2731509,62.3271238 43.9371984,73.6624789 30.0037346,73.6624789 Z" />
          <polygon points="29.5 4.73630358 29.5 75.2163185 46.245232 70.9288576 57.0408043 55.0855416 57.0408043 43.61441 48.6732325 24.8191448" />
        </g>
      </g>
    </svg>
  )
}

export function TransparencyWhite() {
  return (
    <svg
      width="100px"
      height="100px"
      viewBox="0 0 100 100"
      xmlns="http://www.w3.org/2000/svg">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          transform="translate(18.000000, 28.000000)"
          fill="#ffffff"
          fillRule="nonzero">
          <path d="M31.5,13 C26.8107891,13 23,16.8107891 23,21.5 C23,26.1892109 26.8107891,30 31.5,30 C36.1892109,30 40,26.1892109 40,21.5 C40,16.8107891 36.1890781,13 31.5,13 Z" />
          <path d="M32,0 C17.4545207,0 5.03276558,8.91524375 0,21.5 C5.03276558,34.0846219 17.4545207,43 32,43 C46.5599339,43 58.9672344,34.0846219 64,21.5 C58.9672344,8.91524375 46.5599339,0 32,0 Z M32,35.8332438 C23.9709205,35.8332438 17.4545207,29.4118656 17.4545207,21.4998656 C17.4545207,13.5878656 23.9709205,7.16662188 32,7.16662188 C40.0290795,7.16662188 46.5454793,13.588 46.5454793,21.5 C46.5454793,29.412 40.0290795,35.8332438 32,35.8332438 Z" />
        </g>
      </g>
    </svg>
  )
}

export function CloudCoverWhite() {
  return (
    <svg
      width="100px"
      height="100px"
      viewBox="0 0 100 100"
      xmlns="http://www.w3.org/2000/svg">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          transform="translate(17.000000, 12.000000)"
          fill="#ffffff"
          fillRule="nonzero">
          <path d="M40,5.83333333 L40,1.16666667 C40,0.522379667 39.5522461,0 39,0 C38.4477539,0 38,0.522379667 38,1.16666667 L38,5.83333333 C38,6.47762048 38.4477539,7 39,7 C39.5522461,7 40,6.47762048 40,5.83333333 Z" />
          <path d="M64.8333333,26 L60.1666667,26 C59.5223795,26 59,26.447754 59,27 C59,27.5522461 59.5223795,28 60.1666667,28 L64.8333333,28 C65.4776205,28 66,27.5522461 66,27 C66,26.447754 65.4776205,26 64.8333333,26 Z" />
          <path d="M10.3175779,66 L52.5782081,66 C58.885848,66 64,60.8644726 64,54.5293412 C64,48.1942099 58.885848,43.0587823 52.5782081,43.0587823 C51.8180566,43.0604626 51.0601359,43.1371945 50.3156002,43.2878576 C49.6965479,43.4133168 49.0942269,43.0111751 48.9698588,42.3900399 C48.8638949,41.8635592 48.7110839,41.3471599 48.5130987,40.8481235 C48.3563835,40.4588638 48.1740142,40.0802457 47.9671057,39.7150697 C47.9302973,39.6495397 47.8962772,39.5817692 47.8527763,39.5167994 C47.6704069,39.2126727 47.4707486,38.9197478 47.2543591,38.6391448 C47.1617802,38.5243271 47.0692013,38.399428 46.9710453,38.2834902 C46.7780794,38.0527348 46.5734017,37.8326211 46.35757,37.6225889 C46.2136822,37.4825675 46.0631019,37.3520674 45.9097332,37.2226876 C45.7959614,37.1201919 45.666574,37.0238571 45.5422058,36.9286424 C45.2890079,36.7342927 45.0257713,36.553385 44.7541691,36.3864793 C44.6158583,36.3013462 44.4764321,36.2190137 44.3325444,36.1417218 C44.1406939,36.0375458 43.9454972,35.9378505 43.7441659,35.8471167 C43.4876217,35.732299 43.2260583,35.6270028 42.9572445,35.536269 C42.8178184,35.4881015 42.67895,35.4432947 42.5372929,35.4018484 C42.19542,35.302153 41.8485276,35.2226209 41.4977314,35.1632517 C41.411845,35.1498097 41.3254007,35.1402882 41.2406296,35.1290865 C40.8346206,35.0685973 40.4247076,35.0355522 40.014237,35.0293912 C38.6958231,35.0299514 37.3935826,35.3189557 36.1978638,35.8768012 C35.9089728,36.0106616 35.5776962,36.0173828 35.2837858,35.895284 C34.9898755,35.7737454 34.7601012,35.5340287 34.6491179,35.2343827 C32.8137117,30.2989059 28.1278771,27.019603 22.8815491,27 C22.5385606,27 22.2134189,27.025204 21.8821423,27.051528 C17.9865751,27.3511739 14.4535159,29.4593371 12.3292188,32.7526421 C10.2054793,36.0459471 9.73421891,40.1463358 11.0554213,43.8384219 C11.1775585,44.184555 11.1279228,44.5682138 10.9215721,44.8712204 C10.7152213,45.1742268 10.3766947,45.3596153 10.0113981,45.3702568 C4.38192695,45.5141988 -0.0824990088,50.1825147 0.00115669382,55.8371417 C0.0848123964,61.4917688 4.68643378,66.0245439 10.3175779,66 L10.3175779,66 Z" />
          <path d="M23.9848375,25.5157101 C24.1688983,25.5299405 24.3495921,25.5540225 24.5308471,25.573726 C24.7126633,25.5939767 24.875961,25.6098491 25.0459928,25.6355729 C25.2160246,25.661297 25.4045747,25.6996092 25.5835851,25.731901 C25.7631566,25.7647401 25.9214039,25.7915587 26.0869465,25.8282291 C26.252489,25.8654468 26.4320605,25.9158001 26.6110709,25.9606803 C26.7906424,26.0055604 26.9444004,26.0433254 27.1088205,26.0920368 C27.2732407,26.1402008 27.4421502,26.2036898 27.608815,26.2567797 C27.7754798,26.3093222 27.9410223,26.3684327 28.1026367,26.4248065 C28.2648121,26.4806329 28.4247431,26.554521 28.5857962,26.6207465 C28.7462883,26.6869722 28.9095862,26.7499137 29.0672724,26.8216125 C29.2243975,26.8933113 29.3775944,26.973767 29.5268631,27.0454658 C29.676132,27.1171646 29.8416745,27.197073 29.9954326,27.2786236 C30.1497519,27.3607213 30.290042,27.449387 30.435944,27.5342213 C30.5818457,27.6196032 30.742899,27.7082687 30.8955348,27.8024075 C31.0481705,27.8965464 31.174993,27.9906852 31.3152832,28.0859185 C31.4550124,28.1811521 31.6093315,28.2796694 31.7518665,28.3842073 C31.8944013,28.4881978 32.0150509,28.5889044 32.1469238,28.6923477 C32.2793578,28.7952435 32.4297489,28.9085385 32.5655498,29.0229281 C32.7007896,29.1373178 32.8124606,29.2473288 32.9364773,29.3589818 C33.0604938,29.4711821 33.2041511,29.5948762 33.333218,29.7191174 C33.461724,29.8433588 33.5627328,29.9577485 33.6777709,30.0776112 C33.7928089,30.197474 33.9286099,30.3310197 34.0481372,30.4634708 C34.1676644,30.5953747 34.2585724,30.7157848 34.3640708,30.8411207 C34.4695689,30.9664567 34.6020031,31.1147801 34.7086236,31.2581776 C34.8158054,31.401575 34.9100804,31.5362154 35.009967,31.6752344 C35.1098537,31.8142534 35.21928,31.954367 35.3157998,32.0988591 C35.4123194,32.2433512 35.5211847,32.4294394 35.6238772,32.595277 C35.7030008,32.7255389 35.7888584,32.8519696 35.8651763,32.9855152 C36.0374528,33.2881825 36.1990671,33.5979648 36.3500194,33.9148623 C37.9717746,33.3626178 39.7029562,33.1869284 41.4066409,33.4014773 C41.5216789,33.4135184 41.636717,33.4261068 41.7511937,33.4414317 C42.1445676,33.4989001 42.5340133,33.576072 42.9189697,33.6724001 C43.0962966,33.7161856 43.2640836,33.7698229 43.4408494,33.8218181 C43.6546517,33.8864017 43.8656482,33.9581005 44.0738389,34.0358197 C44.4391548,34.1666289 44.7966143,34.3165941 45.1450952,34.4840737 C45.2489101,34.534427 45.353286,34.5814965 45.4554173,34.6351337 C46.1950274,35.020446 46.8891836,35.4845722 47.5244177,36.0187552 C47.5968076,36.0800549 47.6680749,36.1429966 47.7393424,36.2070329 C48.0406858,36.4719351 48.3274391,36.7532569 48.5973575,37.0488089 C48.7309139,37.193301 48.8616643,37.3388878 48.9873644,37.4904951 C49.1125033,37.641555 49.2320306,37.7882364 49.3470685,37.9442223 C49.5765835,38.2501734 49.7887023,38.5670709 49.9834251,38.8960094 C50.0041881,38.9315851 50.0316851,38.9644243 50.0535702,39 C55.1309547,34.2476321 56.449683,26.8270858 53.3094262,20.6850757 C50.1686082,14.5430657 43.2977534,11.1059045 36.3511418,12.2021838 C29.403969,13.2984631 23.9949384,18.672585 23,25.4675461 C23.1565638,25.4675461 23.310322,25.4828711 23.4657635,25.4899862 C23.6391624,25.4976486 23.8125611,25.5020272 23.9848375,25.5157101 Z" />
          <path d="M23.672555,11.0228763 L19.0060607,6.3563819 C18.7126958,6.05276359 18.2791995,5.93143022 17.871337,6.03795302 C17.4634744,6.14504542 17.1450454,6.46347445 17.037953,6.87133685 C16.9314302,7.27919954 17.0527637,7.71326547 17.356382,8.00606057 L22.0228763,12.6725549 C22.4802976,13.1145959 23.208298,13.10833 23.658314,12.658314 C24.1083299,12.2082981 24.1145959,11.4802976 23.672555,11.0228763 Z" />
          <path d="M54.9979618,12.6453924 L59.6456164,7.99789433 C59.9474416,7.70629113 60.0682852,7.27399219 59.9621924,6.86778982 C59.8560998,6.46158774 59.5383891,6.14445497 59.1321731,6.03779852 C58.7259572,5.93170935 58.294211,6.0525488 58.0025979,6.35493115 L53.3549432,11.0024292 C53.0525507,11.2940326 52.931707,11.7263316 53.0377998,12.1325337 C53.1444598,12.5387361 53.4616033,12.8558687 53.8678192,12.9619579 C54.2740351,13.0686143 54.7057813,12.9472076 54.9979618,12.6453924 Z" />
        </g>
      </g>
    </svg>
  )
}

export function FilterIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <rect id="Rectangle 950" width="16" height="16" rx="1" fill="#1FB8ED" />
      <g transform="translate(4.5,6.5)">
        <path
          width="8"
          id="Vector 191"
          d="M2.62268e-07 1.58735e-08L4 3L8 7.15256e-07L2.62268e-07 1.58735e-08Z"
          fill="#FBFBFE"
        />
      </g>
    </svg>
  )
}

export function DailyLogbookIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30.33 29.28">
      <g opacity="0.5">
        <path fill="#fff" d="M4.92,22.18h5L8.25,24.49H6.58Z" />
      </g>
      <circle fill="#fff" cx="7.41" cy="26.24" r="0.75" />
      <path
        fill="#fff"
        d="M11.92,5.93a.74.74,0,0,1-.75-.75v-3a.75.75,0,1,1,1.5,0v3A.75.75,0,0,1,11.92,5.93Z"
      />
      <path
        fill="#fff"
        d="M21.92,5.93a.74.74,0,0,1-.75-.75v-3a.75.75,0,1,1,1.5,0v3A.75.75,0,0,1,21.92,5.93Z"
      />
      <path
        fill="#fff"
        d="M12.92,12.18h2a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1h-2a1,1,0,0,1-1-1h0A1,1,0,0,1,12.92,12.18Z"
      />
      <g opacity="0.5">
        <path
          fill="#fff"
          d="M12.92,16.18h2a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1h-2a1,1,0,0,1-1-1h0A1,1,0,0,1,12.92,16.18Z"
        />
      </g>
      <g opacity="0.5">
        <path
          fill="#fff"
          d="M18.92,12.18h2a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1h-2a1,1,0,0,1-1-1h0A1,1,0,0,1,18.92,12.18Z"
        />
      </g>
      <path
        fill="#fff"
        d="M18.92,16.18h2a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1h-2a1,1,0,0,1-1-1h0A1,1,0,0,1,18.92,16.18Z"
      />
      <path
        fill="#fff"
        d="M7.42,9.18v10a2.36,2.36,0,0,0,.21,1H9.92a1,1,0,0,1-1-1v-10Z"
      />
      <path
        fill="#fff"
        d="M23.92,4.68h-14a2.5,2.5,0,0,0-2.5,2.5v.5h1.5v-.5a1,1,0,0,1,1-1h14a1,1,0,0,1,1,1v12a1,1,0,0,1-1,1H11.42v1.5h12.5a2.51,2.51,0,0,0,2.5-2.5v-12A2.51,2.51,0,0,0,23.92,4.68Z"
      />
      <path fill="#fff" d="M8.92,9.18h-.5v.75H9.87A1,1,0,0,0,8.92,9.18Z" />
      <path fill="#fff" d="M10.7,8.43a2.49,2.49,0,0,1,.69,1.5h14V8.43Z" />
      <path
        fill="#fff"
        d="M9.92,20.18v-10a1,1,0,0,0-1-1h-3a1,1,0,0,0-1,1v10Z"
      />
      <path
        fill="#fff"
        d="M9.92,20.18v-10a1,1,0,0,0-1-1h-3a1,1,0,0,0-1,1v10Z"
      />
    </svg>
  )
}

export function DashboardsIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30.33 29.28">
      <rect fill="#fff" x="6.17" y="4.47" width="8" height="13" rx="1" ry="1" />
      <rect
        fill="#fff"
        opacity="0.5"
        x="16.17"
        y="11.47"
        width="8"
        height="13"
        rx="1"
        ry="1"
      />
      <rect fill="#fff" x="16.17" y="4.47" width="8" height="5" rx="1" ry="1" />
      <rect fill="#fff" x="6.17" y="19.47" width="8" height="5" rx="1" ry="1" />
    </svg>
  )
}

export function DailyLogbookStatusIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30.33 29.28">
      <path
        fill="#fff"
        d="M11.17,5.56a.75.75,0,0,1-.75-.75v-3a.75.75,0,0,1,1.5,0v3A.76.76,0,0,1,11.17,5.56Z"
      />
      <path
        fill="#fff"
        d="M21.17,5.56a.75.75,0,0,1-.75-.75v-3a.75.75,0,1,1,1.5,0v3A.76.76,0,0,1,21.17,5.56Z"
      />
      <path
        fill="#fff"
        d="M12.17,11.81h2a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1h-2a1,1,0,0,1-1-1h0A1,1,0,0,1,12.17,11.81Z"
      />
      <g opacity="0.5">
        <path
          fill="#fff"
          d="M18.17,11.81h2a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1h-2a1,1,0,0,1-1-1h0A1,1,0,0,1,18.17,11.81Z"
        />
      </g>
      <path
        fill="#fff"
        d="M18.17,15.81h2a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1h-2a1,1,0,0,1-1-1h0A1,1,0,0,1,18.17,15.81Z"
      />
      <rect fill="#fff" x="7.67" y="8.06" width="17" height="1.5" />
      <path
        fill="#fff"
        d="M23.17,4.31h-14a2.5,2.5,0,0,0-2.5,2.5v7.5h1.5V6.81a1,1,0,0,1,1-1h14a1,1,0,0,1,1,1v12a1,1,0,0,1-1,1h-6.5v1.5h6.5a2.51,2.51,0,0,0,2.5-2.5v-12A2.51,2.51,0,0,0,23.17,4.31Z"
      />
      <path
        fill="#fff"
        d="M14.17,15.81h-8a1,1,0,0,0-1,1v8a1,1,0,0,0,1,1h8a1,1,0,0,0,1-1v-8A1,1,0,0,0,14.17,15.81Zm-.42,3.47-3.23,4a.77.77,0,0,1-.59.28.76.76,0,0,1-.43-.14l-2.77-2a.75.75,0,0,1,.88-1.22L9.8,21.78l2.78-3.45a.75.75,0,1,1,1.17,1Z"
      />
    </svg>
  )
}

export function HomeIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30.33 29.28">
      <path
        fill="#fff"
        d="M24.11,23.79h-1.5v-9A1.74,1.74,0,0,1,24.35,13a.23.23,0,0,0,.22-.15.22.22,0,0,0-.07-.27L15.65,4.93a.26.26,0,0,0-.33,0L6.48,12.62a.22.22,0,0,0-.07.27.21.21,0,0,0,.22.15,1.74,1.74,0,0,1,1.74,1.74v9H6.87v-9a.24.24,0,0,0-.24-.24,1.74,1.74,0,0,1-1.14-3L14.34,3.8a1.76,1.76,0,0,1,2.3,0l8.85,7.69a1.74,1.74,0,0,1-1.14,3,.24.24,0,0,0-.24.24Z"
      />
      <g opacity="0.5">
        <path
          fill="#fff"
          d="M13,23.79H8.62a1,1,0,0,1-1-1v-8a1,1,0,0,0-1-1A1,1,0,0,1,6,12.06l8.85-7.7a1,1,0,0,1,1.31,0L25,12.06a1,1,0,0,1-.64,1.73,1,1,0,0,0-1,1v8a1,1,0,0,1-1,1H18v-6a1,1,0,0,0-1-1H14a1,1,0,0,0-1,1Z"
        />
      </g>
    </svg>
  )
}

export function LogbookIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30.33 29.28">
      <rect
        fill="#fff"
        x="7.18"
        y="11.07"
        width="13.96"
        height="5"
        transform="translate(-5.45 13.99) rotate(-45)"
      />
      <g opacity="0.5">
        <path
          fill="#fff"
          d="M19.84,4.35a1,1,0,0,1,1.42,0l2.12,2.12a1,1,0,0,1,0,1.42L22,9.3,18.43,5.76Z"
        />
      </g>
      <g opacity="0.5">
        <path fill="#fff" d="M6.41,17.78l3.53,3.54-2.81.45L6,20.6Z" />
      </g>
      <path
        fill="#fff"
        d="M14.58,25.39h-7a.75.75,0,1,1,0-1.5h7a.75.75,0,0,1,0,1.5Z"
      />
      <g opacity="0.5">
        <path
          fill="#fff"
          d="M24.58,25.39h-7a.75.75,0,0,1,0-1.5h7a.75.75,0,0,1,0,1.5Z"
        />
      </g>
      <circle fill="#fff" cx="5.33" cy="22.39" r="0.75" />
    </svg>
  )
}

export function LogbookFormsIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30.33 29.28">
      <path
        fill="#fff"
        d="M18.33,17.66h-12a2,2,0,0,1-2-2v-8a2,2,0,0,1,2-2h12a2,2,0,0,1,2,2v8A2,2,0,0,1,18.33,17.66Zm-12-10.5a.5.5,0,0,0-.5.5v8a.5.5,0,0,0,.5.5h12a.5.5,0,0,0,.5-.5v-8a.5.5,0,0,0-.5-.5Z"
      />
      <g opacity="0.5">
        <rect fill="#fff" x="11.33" y="11.66" width="15" height="12" rx="2" />
      </g>
      <circle fill="#fff" cx="15.33" cy="9.66" r="1" />
      <g opacity="0.5">
        <circle fill="#fff" cx="12.33" cy="9.66" r="1" />
      </g>
      <g opacity="0.5">
        <circle fill="#fff" cx="9.33" cy="9.66" r="1" />
      </g>
    </svg>
  )
}

export function MapsIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30.33 29.28">
      <path
        fill="#fff"
        d="M15.46,20.92l-.53-.53c-.17-.17-.38-.39-.62-.68a25.62,25.62,0,0,1-2-2.78c-1.28-2-2.81-5-2.81-7.62a6,6,0,0,1,12,0c0,2.66-1.53,5.61-2.81,7.62a25.62,25.62,0,0,1-2,2.78c-.24.28-.45.51-.62.68Zm0-16.11A4.51,4.51,0,0,0,11,9.31c0,1.79.91,4.21,2.57,6.81a25.11,25.11,0,0,0,1.92,2.62h0a23.7,23.7,0,0,0,1.92-2.62C19,13.52,20,11.1,20,9.31A4.51,4.51,0,0,0,15.46,4.81Z"
      />
      <path
        fill="#fff"
        d="M15.46,4.06a5.25,5.25,0,0,0-5.25,5.25c0,2.27,1.27,5,2.69,7.22a25.15,25.15,0,0,0,2,2.7c.22.26.42.47.58.63.16-.16.35-.37.58-.63a25.24,25.24,0,0,0,2-2.7c1.43-2.23,2.7-5,2.7-7.22A5.25,5.25,0,0,0,15.46,4.06Zm0,8.25a3,3,0,1,1,3-3A3,3,0,0,1,15.46,12.31Z"
      />
      <g opacity="0.5">
        <path
          fill="#fff"
          d="M27.46,24.06h-24a.76.76,0,0,1-.68-.43.75.75,0,0,1,.09-.79l4-5a.74.74,0,0,1,.59-.28h2a.75.75,0,0,1,0,1.5H7.82L5,22.56H25.9l-2.8-3.5H21.46a.75.75,0,0,1,0-1.5h2a.72.72,0,0,1,.58.28l4,5a.75.75,0,0,1-.58,1.22Z"
        />
      </g>
    </svg>
  )
}

export function SensorsIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30.33 29.28">
      <path
        fill="#fff"
        d="M14.82,10.35a4,4,0,1,0,4,4A4,4,0,0,0,14.82,10.35Zm0,6a2,2,0,1,1,2-2A2,2,0,0,1,14.82,16.35Z"
      />
      <path
        fill="#fff"
        d="M21.8,14.6a.74.74,0,0,1-.74-.7,6.27,6.27,0,0,0-6.24-5.8.75.75,0,0,1,0-1.5,7.77,7.77,0,0,1,7.73,7.2.75.75,0,0,1-.69.8Z"
      />
      <path
        fill="#fff"
        d="M24.82,15.1h-7a.75.75,0,0,1,0-1.5H24a9.24,9.24,0,0,0-9.22-8.5.75.75,0,0,1,0-1.5A10.75,10.75,0,0,1,25.56,13.78a.92.92,0,0,1,0,.29.82.82,0,0,1,.05.28A.75.75,0,0,1,24.82,15.1Z"
      />
      <g opacity="0.5">
        <path
          fill="#fff"
          d="M14.82,25.1a10.75,10.75,0,0,1,0-21.5.75.75,0,1,1,0,1.5,9.25,9.25,0,0,0,0,18.5.75.75,0,0,1,0,1.5Z"
        />
      </g>
      <g opacity="0.5">
        <path
          fill="#fff"
          d="M4.82,15.1a.76.76,0,0,1-.75-.75A10.76,10.76,0,0,1,14.82,3.6a.75.75,0,1,1,0,1.5,9.26,9.26,0,0,0-9.25,9.25A.75.75,0,0,1,4.82,15.1Z"
        />
      </g>
      <g opacity="0.5">
        <path
          fill="#fff"
          d="M14.82,22.1a7.75,7.75,0,0,1,0-15.5.75.75,0,0,1,0,1.5,6.25,6.25,0,0,0,0,12.5.75.75,0,0,1,0,1.5Z"
        />
      </g>
      <g opacity="0.5">
        <path
          fill="#fff"
          d="M7.82,15.1a.76.76,0,0,1-.75-.75A7.76,7.76,0,0,1,14.82,6.6a.75.75,0,0,1,0,1.5,6.26,6.26,0,0,0-6.25,6.25A.75.75,0,0,1,7.82,15.1Z"
        />
      </g>
    </svg>
  )
}

export function EnvironmentIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30.33 29.28">
      <path
        fill="#fff"
        d="M8,16.29H22a4,4,0,1,0,0-8,3.8,3.8,0,0,0-1.27.21A6,6,0,0,0,9,10.29v.17a3,3,0,1,0-1,5.83Z"
      />
      <path
        fill="#fff"
        d="M9,21.16a.73.73,0,0,1-.53-.22.75.75,0,0,1,0-1.06l2.12-2.12a.75.75,0,1,1,1.06,1.06L9.52,20.94A.74.74,0,0,1,9,21.16Z"
      />
      <path
        fill="#fff"
        d="M16.05,21.16a.74.74,0,0,1-.53-.22.75.75,0,0,1,0-1.06l2.12-2.12a.75.75,0,1,1,1.06,1.06l-2.12,2.12A.74.74,0,0,1,16.05,21.16Z"
      />
      <g opacity="0.5">
        <path
          fill="#fff"
          d="M11,26.16a.73.73,0,0,1-.53-.22.75.75,0,0,1,0-1.06l2.12-2.12a.75.75,0,1,1,1.06,1.06l-2.12,2.12A.74.74,0,0,1,11,26.16Z"
        />
      </g>
      <g opacity="0.5">
        <path
          fill="#fff"
          d="M18,26.16a.73.73,0,0,1-.53-.22.75.75,0,0,1,0-1.06l2.12-2.12a.75.75,0,1,1,1.06,1.06l-2.12,2.12A.74.74,0,0,1,18,26.16Z"
        />
      </g>
    </svg>
  )
}

export function FeedingIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30.33 29.28">
      <circle fill="#fff" cx="19.67" cy="9.72" r="3" />
      <path
        fill="#fff"
        d="M10.67,22.72a4,4,0,1,1,4-4A4,4,0,0,1,10.67,22.72Zm0-6.5a2.5,2.5,0,1,0,2.5,2.5A2.51,2.51,0,0,0,10.67,16.22Z"
      />
      <g opacity="0.5">
        <circle fill="#fff" cx="19.67" cy="18.72" r="2" />
      </g>
      <g opacity="0.5">
        <circle fill="#fff" cx="10.67" cy="9.72" r="2" />
      </g>
    </svg>
  )
}

export function SeaLiceIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30.33 29.28">
      <path
        fill="#fff"
        d="M17.76,26.07H12.57a2.21,2.21,0,0,1-2.2-2.2V19.14H5.65A2.19,2.19,0,0,1,3.45,17v-5.2a2.19,2.19,0,0,1,2.2-2.19h4.72V4.83a2.21,2.21,0,0,1,2.2-2.2h5.19A2.21,2.21,0,0,1,20,4.83V9.56h4.73a2.19,2.19,0,0,1,2.19,2.19V17a2.19,2.19,0,0,1-2.19,2.19H20v4.73A2.21,2.21,0,0,1,17.76,26.07Zm-12.11-15a.69.69,0,0,0-.7.69V17a.69.69,0,0,0,.7.69h6.22v6.23a.7.7,0,0,0,.7.7h5.19a.7.7,0,0,0,.7-.7V17.64h6.23a.69.69,0,0,0,.69-.69v-5.2a.69.69,0,0,0-.69-.69H18.46V4.83a.7.7,0,0,0-.7-.7H12.57a.7.7,0,0,0-.7.7v6.23Z"
      />
    </svg>
  )
}

export function SatellitesIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30.33 29.28">
      <mask id="mask" x="11.28" y="2.92" width="14.9" height="14.9">
        <g id="path-50-inside-1">
          <rect
            fill="#fff"
            x="13.23"
            y="6.87"
            width="11"
            height="7"
            rx="1"
            ry="1"
            transform="translate(-1.85 16.28) rotate(-45)"
          />
        </g>
      </mask>
      <path
        fill="#fff"
        d="M17.32,20a8.26,8.26,0,0,1-8.25-8.25.75.75,0,0,1,1.5,0,6.75,6.75,0,0,0,6.75,6.75.75.75,0,0,1,0,1.5Z"
      />
      <path
        fill="#fff"
        d="M17.32,23.85A12.08,12.08,0,0,1,5.25,11.79a.75.75,0,0,1,1.5,0A10.58,10.58,0,0,0,17.32,22.35a.75.75,0,0,1,0,1.5Z"
      />
      <g opacity="0.5">
        <path
          fill="#fff"
          d="M17.32,27.39a15.61,15.61,0,0,1-15.6-15.6.75.75,0,0,1,1.5,0,14.12,14.12,0,0,0,14.1,14.1.75.75,0,0,1,0,1.5Z"
        />
      </g>
      <g opacity="0.5">
        <path
          fill="#fff"
          d="M23.68,10.37l3.53,3.54a1,1,0,0,1,0,1.41l-3.53,3.54a1,1,0,0,1-1.41,0l-3.54-3.54Z"
        />
      </g>
      <g opacity="0.5">
        <path
          fill="#fff"
          d="M13.78,1.89a1,1,0,0,1,1.41,0l3.54,3.53-5,4.95L10.24,6.84a1,1,0,0,1,0-1.42Z"
        />
      </g>
      <g mask="#mask">
        <path
          fill="#fff"
          d="M17.32,17.82a2.46,2.46,0,0,1-1.77-.73L12,13.55A2.5,2.5,0,0,1,12,10l6.37-6.37a2.5,2.5,0,0,1,3.53,0l3.54,3.54a2.5,2.5,0,0,1,0,3.53l-6.37,6.37A2.45,2.45,0,0,1,17.32,17.82Zm-2.83-6,2.83,2.82L23,9,20.14,6.13Z"
        />
      </g>
    </svg>
  )
}

export function MonitoringAlertsIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30.33 29.28">
      <path
        fill="#fff"
        d="M24.48,8.56,16,3.64a1,1,0,0,0-1,0L6.43,8.56a1,1,0,0,0-.5.87v9.84a1,1,0,0,0,.5.87L15,25.06a1,1,0,0,0,1,0l8.52-4.92a1,1,0,0,0,.5-.87V9.43A1,1,0,0,0,24.48,8.56Zm-8,11.79h-2v-2h2Zm0-4h-2v-9h2Z"
      />
    </svg>
  )
}

export function DataBrowserIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30.33 29.28">
      <g opacity="0.5">
        <path
          fill="#fff"
          d="M3.92,7.57h22.5a.75.75,0,0,1,.75.75h0a.76.76,0,0,1-.75.75H3.92a.75.75,0,0,1-.75-.75h0A.74.74,0,0,1,3.92,7.57Z"
        />
      </g>
      <g opacity="0.5">
        <path
          fill="#fff"
          d="M3.92,13.57h22.5a.75.75,0,0,1,.75.75h0a.76.76,0,0,1-.75.75H3.92a.75.75,0,0,1-.75-.75h0A.74.74,0,0,1,3.92,13.57Z"
        />
      </g>
      <g opacity="0.5">
        <path
          fill="#fff"
          d="M3.92,19.57h22.5a.75.75,0,0,1,.75.75h0a.76.76,0,0,1-.75.75H3.92a.75.75,0,0,1-.75-.75h0A.74.74,0,0,1,3.92,19.57Z"
        />
      </g>
      <circle fill="#fff" cx="8.17" cy="14.57" r="2.42" />
      <circle fill="#fff" cx="16.2" cy="20.32" r="2.42" />
      <polygon
        fill="#fff"
        points="16.43 21.71 7.72 15.17 8.62 13.97 15.9 19.43 21.5 8.23 22.84 8.9 16.43 21.71"
      />
      <circle fill="#fff" cx="22.17" cy="8.57" r="3" />
    </svg>
  )
}

export function TransferPerformance() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30.33 29.28">
      <path
        fill="#ffffff"
        d="M18.42,4.82H15.76v7.33H14.28V4.82H11.65V3.62h6.77Z"
      />
      <rect
        fill="#ffffff"
        x="3.51"
        y="12.68"
        width="5.82"
        height="11.53"
        rx="1"
        ry="1"
      />
      <g opacity="0.5">
        <rect
          fill="#ffffff"
          x="12.2"
          y="14.12"
          width="5.82"
          height="10.09"
          rx="1"
          ry="1"
        />
      </g>
      <rect
        fill="#ffffff"
        x="20.88"
        y="7.38"
        width="5.82"
        height="16.83"
        rx="1"
        ry="1"
      />
    </svg>
  )
}

export function SamplingDistributionFrequency() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30.33 29.28">
      <rect
        fill="#ffffff"
        x="11.77"
        y="2.51"
        width="6.29"
        height="6.29"
        rx="1.75"
        ry="1.75"
      />
      <path
        fill="#ffffff"
        d="M24.81,26.77H22a2.5,2.5,0,0,1-2.5-2.5V21.49A2.5,2.5,0,0,1,22,19h2.79a2.5,2.5,0,0,1,2.5,2.5v2.78A2.5,2.5,0,0,1,24.81,26.77ZM22,20.49a1,1,0,0,0-1,1v2.78a1,1,0,0,0,1,1h2.79a1,1,0,0,0,1-1V21.49a1,1,0,0,0-1-1Z"
      />
      <path
        fill="#ffffff"
        d="M24.16,16.76h-1.5V14a1,1,0,0,0-1-1h-5a2.5,2.5,0,0,1-2.5-2.49V6.61h1.5v3.86a1,1,0,0,0,1,1h5A2.5,2.5,0,0,1,24.16,14Z"
      />
      <path
        opacity="0.5"
        fill="#ffffff"
        d="M10.54,11.46H8.16A2.5,2.5,0,0,0,5.66,14v5.77H5a1.75,1.75,0,0,0-1.75,1.75v2.79A1.75,1.75,0,0,0,5,26H7.81a1.75,1.75,0,0,0,1.75-1.75V21.48a1.76,1.76,0,0,0-1.75-1.75H7.16V14a1,1,0,0,1,1-1h2.38a.75.75,0,0,0,0-1.5Z"
      />
      <path
        opacity="0.5"
        fill="#ffffff"
        d="M16.31,19.73h-.65V16.6a.75.75,0,0,0-1.5,0v3.13h-.64a1.75,1.75,0,0,0-1.75,1.75v2.79A1.75,1.75,0,0,0,13.52,26h2.79a1.75,1.75,0,0,0,1.75-1.75V21.48A1.76,1.76,0,0,0,16.31,19.73Z"
      />
      <path
        fill="#ffffff"
        d="M23.43,17.73a.74.74,0,0,1-.53-.22l-2.06-2.06a.74.74,0,0,1,0-1.06.75.75,0,0,1,1.06,0l1.53,1.53,1.5-1.5A.75.75,0,1,1,26,15.48l-2,2A.74.74,0,0,1,23.43,17.73Z"
      />
    </svg>
  )
}

export function BiomassVsSensors() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30.33 29.28">
      <path
        fill="#ffffff"
        d="M16.77,10.94a1,1,0,0,0-.4-.87A4.67,4.67,0,0,0,15,9.46a7,7,0,0,1-1.64-.69,2.2,2.2,0,0,1-1.17-1.92A2.07,2.07,0,0,1,13,5.16a3.38,3.38,0,0,1,2.18-.67,3.64,3.64,0,0,1,1.59.33,2.57,2.57,0,0,1,1.1.93,2.42,2.42,0,0,1,.39,1.35H16.77a1.33,1.33,0,0,0-.42-1,1.74,1.74,0,0,0-1.2-.38A1.81,1.81,0,0,0,14,6a1.06,1.06,0,0,0-.4.87.94.94,0,0,0,.44.78,4.85,4.85,0,0,0,1.43.61,6.72,6.72,0,0,1,1.59.67,2.65,2.65,0,0,1,.89.87,2.25,2.25,0,0,1,.28,1.15,2,2,0,0,1-.82,1.69,3.52,3.52,0,0,1-2.21.63,4.18,4.18,0,0,1-1.71-.34,2.8,2.8,0,0,1-1.2-.95,2.33,2.33,0,0,1-.43-1.4h1.48a1.37,1.37,0,0,0,.48,1.12,2.08,2.08,0,0,0,1.38.4,1.82,1.82,0,0,0,1.16-.31A1,1,0,0,0,16.77,10.94Z"
      />
      <rect
        fill="#ffffff"
        x="3.57"
        y="13.67"
        width="5.82"
        height="11.53"
        rx="1"
        ry="1"
      />
      <g opacity="0.5">
        <rect
          fill="#ffffff"
          x="12.25"
          y="15.11"
          width="5.82"
          height="10.09"
          rx="1"
          ry="1"
        />
      </g>
      <rect
        fill="#ffffff"
        x="20.93"
        y="8.37"
        width="5.82"
        height="16.83"
        rx="1"
        ry="1"
      />
    </svg>
  )
}

export function SeawaterMortality() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30.33 29.28">
      <path
        fill="#ffffff"
        d="M12.67,4.34l2.46,6.54,2.45-6.54H19.5v8.53H18V10.06l.15-3.76-2.52,6.57H14.59L12.08,6.31l.14,3.75v2.81H10.75V4.34Z"
      />
      <rect
        fill="#ffffff"
        x="3.57"
        y="13.41"
        width="5.82"
        height="11.53"
        rx="1"
        ry="1"
      />
      <g opacity="0.5">
        <rect
          fill="#ffffff"
          x="12.25"
          y="14.84"
          width="5.82"
          height="10.09"
          rx="1"
          ry="1"
        />
      </g>
      <rect
        fill="#ffffff"
        x="20.93"
        y="8.1"
        width="5.82"
        height="16.83"
        rx="1"
        ry="1"
      />
    </svg>
  )
}

export function OvaMortality() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30.33 29.28">
      <path
        fill="#ffffff"
        d="M18.94,7.93a5.24,5.24,0,0,1-.43,2.2,3.28,3.28,0,0,1-1.24,1.45,3.43,3.43,0,0,1-5-1.44A5.11,5.11,0,0,1,11.87,8V7.49a5.12,5.12,0,0,1,.44-2.2,3.27,3.27,0,0,1,1.25-1.46,3.36,3.36,0,0,1,1.85-.51,3.43,3.43,0,0,1,1.84.5A3.3,3.3,0,0,1,18.5,5.27a5.11,5.11,0,0,1,.44,2.18Zm-1.48-.45a3.78,3.78,0,0,0-.53-2.17,1.78,1.78,0,0,0-1.52-.76,1.74,1.74,0,0,0-1.51.76,3.68,3.68,0,0,0-.55,2.13v.49a3.64,3.64,0,0,0,.55,2.17,1.76,1.76,0,0,0,1.52.77,1.74,1.74,0,0,0,1.51-.75,3.73,3.73,0,0,0,.53-2.19Z"
      />
      <rect
        fill="#ffffff"
        x="3.57"
        y="12.48"
        width="5.82"
        height="11.53"
        rx="1"
        ry="1"
      />
      <g opacity="0.5">
        <rect
          fill="#ffffff"
          x="12.25"
          y="13.92"
          width="5.82"
          height="10.09"
          rx="1"
          ry="1"
        />
      </g>
      <rect
        fill="#ffffff"
        x="20.93"
        y="7.18"
        width="5.82"
        height="16.83"
        rx="1"
        ry="1"
      />
    </svg>
  )
}
